import { render, staticRenderFns } from "./SearchByContentTypeIdField.vue?vue&type=template&id=615b4024"
import script from "./SearchByContentTypeIdField.vue?vue&type=script&lang=js"
export * from "./SearchByContentTypeIdField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports